module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./bg.coffee"));
	}, "bg");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=[name]!./app/locale/bg.coffee
// module id = 188
// module chunks = 97